import msg from './components/msg';
import text from './components/text';
import image from './components/image';
import linear from './components/linear';
import divider from './components/divider';
import fold from './components/fold';
import container from './components/container';

const components = {
  msg,
  text,
  image,
  linear,
  divider,
  fold,
  container,
};

export function renderNode(virtualNode) {
  const { tag, children } = virtualNode;
  const list = [];

  for (let i = 0, len = children.length; i < len; i++) {
    list.push(renderNode(children[i]));
  }

  const tagComponent = components[tag];
  if (tagComponent) {
    return tagComponent.render(virtualNode, list.join(''));
  }
  throw new Error(`unknown tag: ${tag}`);
}

export function render(virtualNode, options) {
  const dir = options.dir || 'c2b';
  return `<div class="msg-${dir} msg-xml" data-guid="${options.seq}">${renderNode(virtualNode)}</div>`;
}
